import type { FunctionComponent } from 'react'

export type ProductSelectListComponents = {
  ActionButtons: FunctionComponent<any>
}

export const components: ProductSelectListComponents = {
  ActionButtons: (_args: any) => null,
}
